import { useEffect } from 'react';

const useKeyPress = (key, eventHandler)=>{
    useEffect(()=>{
        const handler = (event)=>{
            if (event.key === key && eventHandler !== undefined) {
                eventHandler();
            }
        };
        window.addEventListener("keydown", handler);
        return ()=>window.removeEventListener("keydown", handler);
    }, [
        eventHandler,
        key
    ]);
};

export { useKeyPress };
